import { AcceptFulfillmentOrderState } from './acceptFulfillmentOrder.types'

const initialState: AcceptFulfillmentOrderState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
